import Statuses from '@/api/statuses'

export default {
  namespaced: true,
  state: {
    messages: 0
  },
  mutations: {
    setMessages (state, messages) {
      state.messages = messages
    },
    clearStatuses (state) {
      state.messages = 0
    }
  },
  actions: {
    async getStatuses ({ commit }) {
      try {
        const statuses = await Statuses.get()
        commit('setMessages', statuses.messages)
      } catch (err) {
        console.log(`Status Error: ${err.message}`)
      }
    },
    async socket_statusUpdate ({ dispatch }) {
      dispatch('getStatuses')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/status.js